import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/api.process.actions';

import Loading from '../../dialogs/loading';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class Historic extends React.Component {
    state = {
        loading: true,
        data: null,
    };

    constructor(props) {
        super(props);
        props.getHistorial(props.id).then((response) => {
            this.setState({ loading: false, data: response });
        });
    }

    render() {
        const { fullScreen } = this.props;
        const { loading, data } = this.state;
        if (loading) {
            return <Loading open opacity />;
        } else {
            const sortedData = []
                .concat(data)
                .sort((a, b) => (a.fechahora.date > b.fechahora.date ? -1 : 1))
                .map((row, index) => (
                    <div key={index} className="flex_full_row margin_top_32 shadow_down">
                        <div className="flex_40 center margin_bottom_12">
                            <span className={'barlow_medium_tree_local c_slate_grey '}>
                                {row.fechahora.date.substring(0, 19)}
                            </span>
                        </div>
                        <div className="flex_60 center margin_bottom_12">
                            <span className={'barlow_medium_tree_local c_slate_grey'}>
                                {row.texto}
                            </span>
                        </div>
                    </div>
                ));
            return (
                <Dialog
                    fullScreen={fullScreen}
                    open={true}
                    onClose={this.props.handleClose}
                    TransitionComponent={Transition}
                >
                    <AppBar color="default" className={'position_relative bg_bluish'}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                onClick={this.props.handleClose}
                                aria-label="Back"
                                className="hand c_white"
                            >
                                <BlueCloseIcon />
                            </IconButton>
                            <Typography
                                variant="h6"
                                color="inherit"
                                className={'flex_full_row c_white'}
                            >
                                <FormattedMessage id="historic" />
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <div className="flex_scroll_column bg_ice_blue display_flex overflow_y_scroll barlow_medium c_lipstick padding_borders">
                        <div className="flex_full_row shadow_down ">
                            <div className="flex_40 center margin_bottom_12">
                                <span
                                    className={
                                        'barlow_semibold margin_top_18  text_align_center flex_full c_dark_grey_blue '
                                    }
                                >
                                    <FormattedMessage id="date" />
                                </span>
                            </div>
                            <div className="flex_60 center margin_bottom_12">
                                <span
                                    className={
                                        'barlow_semibold margin_top_18  text_align_center flex_full c_dark_grey_blue '
                                    }
                                >
                                    <FormattedMessage id="action" />
                                </span>
                            </div>
                        </div>
                        {sortedData.map((info) => {
                            return info;
                        })}
                    </div>
                </Dialog>
            );
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

Historic = connect(
    null,
    mapDispatchToProps,
)(Historic);

Historic.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(Historic);



// WEBPACK FOOTER //
// ./src/components/complex/forms/Historic.js